export class LandlineConfigurationModel {
    type_operation: string; // registration or portability
    phone_portability?: string;
    operator_portability?: string;
    cp_vat?: string;
    cp_price?: string;
    cp_price_without_vat?: string;
}
